import { SettingType } from '../../types/settings'
import { ISettingsAdapter } from './settingsAdapter'

export const AdapterCollection = () => {
  const mapByInputName: Map<string, ISettingsAdapter<any, any, any>[]> = new Map()
  const mapByVariableName: Map<string, ISettingsAdapter<any, any, any>[]> = new Map()
  const mapByType: Map<SettingType, ISettingsAdapter<any, any, any>[]> = new Map()

  const add = <RawType, UiType, UiOrUnsetType>(adapter: ISettingsAdapter<RawType, UiType, UiOrUnsetType>) => {
    const currentByInputName = mapByInputName.get(adapter.inputName)
    const nextByInputName = [...(currentByInputName || []), adapter]
    mapByInputName.set(adapter.inputName, nextByInputName)

    const currentByVariable = mapByVariableName.get(adapter.variable)
    const nextByVariable = [...(currentByVariable || []), adapter]
    mapByVariableName.set(adapter.variable, nextByVariable)

    const currentTypeList = mapByType.get(adapter.type) || []
    currentTypeList.push(adapter)
    mapByType.set(adapter.type, currentTypeList)
  }

  const getByVariable = (variable: string): ISettingsAdapter<any, any, any>[] => {
    const adapters = mapByVariableName.get(variable)
    if (!adapters) {
      return []
    }
    return adapters
  }

  const getByInputName = (inputName: string): ISettingsAdapter<any, any, any>[] => {
    const adapters = mapByInputName.get(inputName)
    if (!adapters) {
      return []
    }
    return adapters
  }

  const getByType = (type: SettingType): ISettingsAdapter<any, any, any>[] => {
    const adapterList = mapByType.get(type)
    if (!adapterList) {
      return []
    }
    return adapterList
  }

  const getInitialValues = (): Record<string, any> => {
    const initialValues: Record<string, any> = {}
    Array.from(mapByInputName.values()).forEach(adapters => {
      adapters.forEach(adapter => {
        if (adapter.skipFormPopulateOnLoad) {
          return
        }
        initialValues[adapter.inputName] = adapter.initialUiValue
      })
    })
    return initialValues
  }

  return Object.freeze({
    add,
    getByVariable,
    getByInputName,
    getByType,
    getInitialValues
  })
}

export type IAdapterCollection = ReturnType<typeof AdapterCollection>
